import React from 'react';
import { eBulkRateDiscountRule } from 'types/administration/pricing/eBulkRateDiscountRule';
import { Grid } from 'ui-toolkit/components';
import { LabelValueViewer } from './viewers/shared/LabelValueViewer';
import { screamingSnakeCaseToCapitalize } from 'utilities/shared/stringMethods/stringMethods';
import { GrayCard } from './viewers/shared/GrayCard';

interface IUnderwriterProfileTopLevelDataProps {
  effectiveDate: string;
  sunsetDate?: string;
  premiumAsTitleGuaranty: boolean;
  refiDiscountConfig: { reason?: string };
  bulkRateDiscount: eBulkRateDiscountRule;
}

export const UnderwriterProfileTopLevelData: React.FC<IUnderwriterProfileTopLevelDataProps> = ({
  effectiveDate,
  sunsetDate,
  refiDiscountConfig,
  bulkRateDiscount,
  premiumAsTitleGuaranty,
}) => {
  return (
    <GrayCard>
      <Grid columnCount={2}>
        <LabelValueViewer label={'Effective Date'} value={effectiveDate} templateColumns={'1fr 2fr'} />
        <LabelValueViewer label={'Sunset Date'} value={sunsetDate || 'N/A'} templateColumns={'1fr 2fr'} />
        <LabelValueViewer
          label={'Premiums as Title Guaranty'}
          value={String(premiumAsTitleGuaranty)}
          templateColumns={'1fr 2fr'}
        />
        <LabelValueViewer
          label={'Bulk Rate Discount'}
          value={screamingSnakeCaseToCapitalize(bulkRateDiscount)}
          templateColumns={'1fr 2fr'}
        />
        <LabelValueViewer
          label={'ReFi Discount Reason'}
          value={refiDiscountConfig.reason || 'N/A'}
          templateColumns={'1fr 2fr'}
        />
      </Grid>
    </GrayCard>
  );
};
